import React from 'react';

const BookmarksRouteNavigationOptions = {
  title: 'Bookmarks',
  headerTitle: 'Bookmarks',
};

export default BookmarksRouteNavigationOptions;
